<template>

  <div class="vuse-content-wrapper">
     <div v-if="hasAccess('vault')">
    <vuse-section-definition
      v-show="!hideTitle"
      :title="page"
      icon="mdi-lock"
    ></vuse-section-definition>
    <v-container fluid class="">
      <v-row>
        <v-col cols="12" sm="6" md="4">
          <v-text-field
            v-model="filter.SearchTerm"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            solo
            hide-details
          />
        </v-col>
        <v-col cols="12"  sm="6" md="4" v-show="!clientId">
          <client-select v-model="filter.clientId" label="Select Client" solo hide-details />
        </v-col>
        <v-col cols="12" sm="12" md="4" class="text-right">
           <v-btn
            color="info"
            dark
            class="mb-2"
            @click="onAdd()"
            v-show="hasAccess('vault.add')"
          >
            Add Password
          </v-btn>
          <v-btn
            color="info"
            dark
            class="mb-2 ml-1"
            @click="$router.push(`/vault-folder`)"
            v-show="hasAccess('vault.add')"
          >
            <v-icon>folder</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
        <v-card>
          <v-skeleton-loader
            v-if="isLoading"
            class="mx-auto"
            type="table"
          ></v-skeleton-loader>
          <v-data-table
            v-else
            :headers="activeHeaders"
            :items="sortedDataItems"
            :loading="loading"
            class="elevation-1"
            :options.sync="tableOptions"
            :server-items-length="totalItems"
            :footer-props="{
              'items-per-page-options': [10, 20, 30, 40, 50, 100, 200],
            }"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-menu offset-y :close-on-content-click="false">
                  <template v-slot:activator="{ on }">
                    <v-btn rounded class="content-ma-0 mr-2" v-on="on" x-small>
                      <v-icon small>menu</v-icon> Customize Columns
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item dense :key="i" v-for="(header, i) in headers">
                      <v-list-item-title v-if="header.readonly">
                        <v-checkbox
                          v-model="headers[i].active"
                          :label="header.text"
                          :disabled="true"
                        />
                      </v-list-item-title>
                      <v-list-item-title v-else>
                        <v-checkbox
                          v-model="headers[i].active"
                          :label="header.text"
                        />
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-toolbar>
            </template>

            <template v-slot:item.lastUpdated="{ item }">
              <v-chip @click="onEdit(item)" small>
                {{ item.lastUpdated | formatDatetime }}
              </v-chip>
            </template>

            <template v-slot:item.date="{ item }">
              <v-chip small @click="onEdit(item)">
                {{ item.date | formatDate }}
              </v-chip>
            </template>

            <template v-slot:item.userId="{ item }">
              <span @click="onEdit(item)">
                <UsersChip :value="item.taskUsers" />
              </span>
            </template>

            <template v-slot:item.clientId="{ item }">
              <span v-show="item.clientId" @click="onEdit(item)">
                <ClientChip
                  :clientId="item.clientId"
                  :clientName="item.clientName"
                />
              </span>
            </template>

            <template v-slot:item.status="{ item }">
              <span @click="onEdit(item)"
                ><TaskStatusChip :status="item.status"
              /></span>
            </template>

            <template v-slot:item.name="{ item }">
              <span @click="onEdit(item)">
                {{ item.name }}
              </span>
            </template>

            <template v-slot:item.type="{ item }" @click="onEdit(item)">
              <span @click="onEdit(item)">
                <TypeChip :value="item.type" />
              </span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn icon small class="content-ma-0" v-on="on">
                    <v-icon small>mdi-cogs</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    @click="onEdit(item)"
                    v-show="hasAccess('vault.edit')"
                  >
                    <v-list-item-title>
                      <v-icon small left>mdi-pencil</v-icon>Edit
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="onDelete(item)"
                    v-show="hasAccess('vault.delete')"
                  >
                    <v-list-item-title>
                      <v-icon small left>delete</v-icon>Delete
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-card>
        </v-col>
      </v-row>
    </v-container>

    <task-form
      :show="showForm"
      :clientId="clientId"
      :item="selectedItem"
      @onClosed="clearAdd()"
      @onSucceded="refresh()"
    ></task-form>

    <delete-dialog
      :show="showDelete"
      :item="selectedItem"
      @onClosed="clearDelete()"
      @onSucceded="refresh()"
    />
     </div>
     <NoPermission v-else />
  </div>
</template>

<script>
import DeleteDialog from "./PasswordVault/_Delete";
import TaskForm from "./PasswordVault/_Form";
import { mapActions, mapState, mapGetters } from "vuex";
import formatterMixin from "@/mixins/formatterMixin";
import TaskStatusChip from "src/components/TaskStatusChip";
import UsersChip from "components/UsersChip";
import ClientChip from "components/ClientChip";
import TypeChip from "components/TypeChip";
import _ from "lodash";
import { getStorage, setStorage } from "src/utils/helpers";
import ClientSelect from "src/components/ClientSelect.vue";
import NoPermission from "components/NoPermission";

const SETTING_LIST_KEY = "passwordVault-columns";
const defaultHeaders = [
  {
    text: "Action",
    value: "actions",
    sortable: false,
    readonly: true,
    active: true,
  },
  { text: "Name", value: "name", sortable: true, active: true },
  { text: "Folder", value: "fullPath", sortable: true, active: true },
  {
    text: "Clients",
    align: "start",
    sortable: false,
    value: "clientId",
    active: true,
  },
  { text: "URL", value: "url", active: true },
  { text: "Username", value: "username", active: true },
  { text: "Password", value: "password", active: true },
  { text: "Notes", value: "notes", active: true },
  {
    text: "Date Modified",
    value: "lastUpdated",
    sortable: true,
    active: false,
  },
];
export default {
  mixins: [formatterMixin],
  props: {
    clientId: Number,
    hideTitle: Boolean,
  },

  components: {
    TaskForm,
    DeleteDialog,
    TaskStatusChip,
    ClientSelect,
    UsersChip,
    ClientChip,
    TypeChip,
    NoPermission
  },
  data: () => ({
    isEdit: false,
    valid: false,
    namespace: "PasswordVault",
    page: "Password Vault",
    usage: "usage",

    tableOptions: {},

    clients: [],
    users: [],
    statuses: [
      { id: 1, name: "open" },
      { id: 2, name: "closed" },
    ],

    filter: {
      SearchTerm: "",
      clientId: "",
    },

    menu: false,

    keyword: "",
    headers: defaultHeaders.map((item) => {
      let savedHeaders = getStorage(SETTING_LIST_KEY) || [];
      let nowHeader = savedHeaders.filter(
        (saved) => saved.value === item.value
      );

      if (nowHeader) {
        nowHeader = nowHeader[0];
      }
      return {
        ...item,
        ...nowHeader,
      };
    }),
    tasks: [],
    editedItem: {
      id: null,
      clientId: "",
      userId: "",
      user: "",
      name: "",
      type: "",
      description: "",
      status: "",
      date: "",
    },

    showForm: false,
    showDelete: false,
    showTimeClock: false,
    showTimeEntryForm: false,
    selectedItem: {},
  }),
  computed: {
    ...mapGetters("account", ["hasAccess"]),
    ...mapState({
      task: (state) => state.passwordVault,
      account: (state) => state.account.data,
      loading: (state) => state.passwordVault.loadingTable,
      totalItems: (state) => state.passwordVault.metaData.totalEntries,
    }),

    isLoading() {
      return this.loading && this.dataItems.length == 0;
    },

    computedFilter() {
      let { clientId, SearchTerm } = this.filter;
      let { sortBy, page, sortDesc, itemsPerPage } = this.tableOptions;
      let params = {
        PageNumber: page ? page : 1,
        PageSize: itemsPerPage > 0 ? itemsPerPage : 10,
      };

      params.OrderBy = sortBy && sortBy.length > 0 && sortBy[0] ? sortBy[0] : null;

      if (params.OrderBy) {
        params.Ascending = sortDesc && sortDesc.length > 0 && sortDesc[0] ? false : true;
      } else {
        params.Ascending = false;
      }

      if (clientId) {
        params.clientId = clientId;
      }

      if (SearchTerm) {
        params.SearchTerm = SearchTerm;
      }
      return params;
    },

    activeHeaders() {
      return this.headers.filter((header) => header.active);
    },

    sortedDataItems() {
      let dataItems = [...this.dataItems];
      return dataItems;
    },

    dataItems() {
      return this.$store.getters["passwordVault/getAll"];
    },

    getClientId() {
      const { clientId } = this.$route.params;
      if (clientId) {
        return parseInt(clientId);
      }
      if (this.clientId) {
        return this.clientId;
      }
      return false;
    },

    isAutoAdd() {
      return (
        this.optional(this.$route.query, "action", "") === "add-password-vault"
      );
    },
    tags() {
      return this.filter.tags;
    },
  },
  watch: {
    tags() {
      this.taskSearch(this.filter);
    },
    headers: {
      handler() {
        setStorage(SETTING_LIST_KEY, this.headers);
      },
      deep: true,
    },
    tableOptions: {
      handler(n, o) {
        if (JSON.stringify(n) !== JSON.stringify(o)) {
          this.refresh();
        }
      },
      deep: true,
    },

    filter: {
      async handler() {
        await this.refresh(true);
      },
      deep: true,
    },
  },
  async mounted() {
    if (this.clientId) {
      this.filter.clientId = this.clientId;
    }
    await this.refresh();

    if (this.isAutoAdd) {
      this.onAdd();
    }
  },

  beforeDestroy() {
    if (this.clientId) {
      this.clearTableFilter();
    }
    clearInterval(this.timer);
    this.$store.dispatch("passwordVault/clearData");
  },

  methods: {
    ...mapActions("passwordVault", ["clearTableFilter", "applyTableFilter"]),
    ...mapActions({
      taskDelete: "passwordVault/delete",
      taskSearch: "passwordVault/search",
    }),

    refresh: _.debounce(async function () {
      this.refreshTable(true);
    }, 500),

    async refreshTable() {
      this.applyTableFilter({ ...this.computedFilter });
    },

    onAdd() {
      this.showForm = true;
      this.selectedItem = {};
    },

    onMakeTimeClock(item) {
      this.showTimeClock = true;
      this.selectedItem = item;
    },

    clearMakeTimeClock() {
      this.showTimeClock = false;
      this.selectedItem = {};
    },

    onTimeEntryForm(item) {
      this.showTimeEntryForm = true;
      this.selectedItem = item;
    },

    async clearTimeEntryForm() {
      this.showTimeEntryForm = false;
      this.selectedItem = {};
      await this.refresh();
    },

    onEdit(item) {
      if (!this.hasAccess("task.edit")) {
        return false;
      }
      this.showForm = true;
      this.selectedItem = item;
    },
    clearAdd() {
      this.showForm = false;
      this.selectedItem = {};
    },

    clearDelete() {
      this.showDelete = false;
      this.selectedItem = {};
    },

    onDelete(item) {
      this.showDelete = true;
      this.selectedItem = item;
    },

    async deleteItemConfirm() {
      await this.taskDelete(this.editedItem.id);
      this.refresh();
    },
  },
};
</script>
